/**
 * @desc  获取state当中的状态
 * 实时监听state值的变化(最新状态) 使用方法：  this.$store.getters.GET_VISIBLE_WIDTH
 * 类 computed 计算属性，实时获取state中的数据
 */
 export const isloading = state => state.loading;
 /**
  * 获取可视区域 宽度
  * @param {*} state 
  * @returns 
  */
 export const GET_VISIBLE_WIDTH = state => state.visibleWidth;
 /**
  * 获取可视区域 高度
  * @param {*} state 
  * @returns 
  */
 export const GET_VISIBLE_HEIGHT = state => state.visibleHeight;
 /**
  * 获取筛选栏 高度
  * @param {*} state 
  * @returns 
  */
 export const GET_SEARCH_HEIGHT = state => state.searchHeight;
 /**
  * 获取分页栏 高度
  * @param {*} state 
  * @returns 
  */
 export const GET_PAGINATION_HEIGHT = state => state.paginationHeight;
 /**
  * 获取表格 高度
  * @param {*} state 
  * @returns 
  */
 export const GET_TABLE_HEIGHT = state => state.tableHeight;
 


// WEBPACK FOOTER //
// ./src/store/getters.js